import React, { useState, useEffect } from 'react'
import { Row, Col } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CrearUsuario from '../../../components/buttons/crearUsuario';
//Redux
import { connect } from 'react-redux';

//API Calls
const { apiUpdateUserAuth } = require('../../../utils/APIs/APISResume')


const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyUpdate = (props) => {
    const [email, setEmail] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    useEffect(() => {
    }, [email]);

    const updateUser = async () => {
        const body = {
            body:{
                email: newEmail,
            },
            email: email,
            token: userData.token
        }
        const updateUserReq = await apiUpdateUserAuth(body);
        if (updateUserReq.status === 200) {
            props.toastSuccess('Usuario actualizado con exito!');
            props.toggle()
        }
        else {
            props.toastError('Ocurrió un error');
        }
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='12' md='12' xs="12">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='correo'
                            margin="normal"
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                    </Col>
                    <Col lg='12' md='12' xs="12">
                        <TextField
                            required
                            key={`key_newmail`}
                            id={`input_newmail`}
                            fullWidth
                            label='Nuevo Correo'
                            margin="normal"
                            onChange={(e) => { setNewEmail(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                        <CrearUsuario
                            tittle={'Actualizar'}
                            onClick={() => updateUser()}
                            disabled={!(email.includes('@') && newEmail.includes('@'))} />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyUpdate);